import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { baseAPI } from './apiRoutes';
import { SortObject } from '../models/sortObject';
import sortHelper from 'src/app/helpers/sort';
import { LoadingService } from './shared/loading.service';

@Injectable({
  providedIn: 'root',
})
export class LovApiService {
  constructor(public http: HttpClient, public loadingService: LoadingService) {}

  generateApiUrl(section, type) {
    return baseAPI + '/' + section + '/lov/' + type;
  }

  async getDropdownValues(section: string, type: string, sortObject?: SortObject[]): Promise<any> {
    let url = this.generateApiUrl(section, type);
    if (sortObject) {
      url += sortHelper.constructSort(sortObject);
    }
    return this.http.get(url).toPromise();
  }

  async createValue(section: string, type: string, data: any): Promise<any> {
    let url = this.generateApiUrl(section, type);
    return this.http.post(url, data).toPromise();
  }

  async updateValue(section: string, type: string, data: any): Promise<any> {
    let url = this.generateApiUrl(section, type);
    let id = data.identifier;
    return this.http.put(url + '/' + id, data).toPromise();
  }

  async removeValue(section: string, type: string, id: string): Promise<any> {
    let url = this.generateApiUrl(section, type);
    return this.http.delete(url + '/' + id).toPromise();
  }

}
